






import { Vue, Component } from "vue-property-decorator";

@Component({})
class MusicPage extends Vue {}
export default MusicPage;
